function performAction(actionObject) {
    window.ReactNativeWebView.postMessage(JSON.stringify(actionObject));
}

class DeviceUtils {
    static isMobileApp() {
        return window.navigator.userAgent.includes('wallist-mobile');
    }

    static performLogout() {
        performAction({ action: 'logout' });
    }

    static makeCall(fromNumber, toNumber) {
        performAction({
            action: 'makeCall',
            from: fromNumber,
            to: toNumber
        })
    }

    static notifyOverlayOpened({ id } = {}) {
        performAction({ action: 'overlayOpened', id });
    }

    static notifyOverlayClosed({ id } = {}) {
        performAction({ action: 'overlayClosed', id });
    }
}



export default DeviceUtils;
